import { DollarSign } from '@tamagui/lucide-icons';
import { SavingsGoalLayout } from '@unistocks/features/dashboard/components/dashboard-data/savings-goal/layout';
import { queryFilter } from '@unistocks/features/dashboard/components/dashboard-data/savings-goal/query-filter';
import { SavingsGoal } from '@unistocks/features/dashboard/components/dashboard-data/savings-goal/savings-goal';
import {
  SavingsGoalSettingsContentStep,
  SavingsGoalSettingsLayoutStep,
  savingsGoalSchemaFactory
} from '@unistocks/features/dashboard/components/dashboard-data/savings-goal/settings';
import { DashboardItemDescriptor } from '@unistocks/features/dashboard/dashboard-item-descriptor';

export const dashboardItemDescriptor: DashboardItemDescriptor = {
  component: SavingsGoal,
  settingsSteps: [SavingsGoalSettingsContentStep, SavingsGoalSettingsLayoutStep],
  schemaFactory: savingsGoalSchemaFactory,
  defaults: setValue => {
    setValue('layout', SavingsGoalLayout.Chart);
  },
  queryFilter: queryFilter,
  icon: DollarSign
};
